module.exports = __webpack_public_path__ + "img/corp.b7414457.png";